import React, { useEffect, useRef, useState } from 'react'
import styles from "./bomListing.module.css";
import BomListTable from '../../components/OtherComps/BomListTable/BomListTable'
import { getMatchedProductsThunk, setQuantities, setSelectedProducts, toggleProductSelection, updateQuantity } from '../../redux/bomSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProductTable from '../../components/OtherComps/ProductTable/ProductTable';
import { addToCartThunk } from '../../redux/cartSlice';
import { addToScheduleThunk } from '../../redux/ScheduleSlice';
import { toast } from 'react-toastify';
import QuotePopup from '../../components/OtherComps/QuotePopup/QuotePopup';
import { setLoginpopup } from '../../redux/customerSlice';

const BomListing = () => {
    const { loading, macthedProducts, quantities, selectedProducts } = useSelector((state) => state.bom)
    const { isLoggedin } = useSelector((state) => state.customer)
    const navigate = useNavigate()
    const location = useLocation();
    const dispatch = useDispatch()
    // const [quantities, setQuantities] = useState({});
    const queryParams = new URLSearchParams(location.search);
    const [editingProduct, setEditingProduct] = useState(null);
    const [newPartNumber, setNewPartNumber] = useState("");
    const [showLogin, setShowLogin] = useState(false)
    const [cartLoading, setLoadingCart] = useState({});
    const [scheduleLoading, setScheduleloading] = useState({})
    const dropdownRef = useRef(null);

    const [productData, setProductData] = useState(() => {
        const raw = location.state?.data || [];
        return Array.isArray(raw)
            ? raw.filter(item => {
                const p = item?.productNumber ? String(item.productNumber).trim().toLowerCase() : '';
                return p && p !== 'id' && p !== '-';
            })
            : [];
    });


    useEffect(() => {
        if (productData.length > 0) {
            dispatch(getMatchedProductsThunk(productData));
        }
    }, [productData])


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setEditingProduct(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);





    const handleQuantityChange = (productId, value) => {
        dispatch(updateQuantity({
            productNumber: productId,
            quantity: value
        }))

    };

    const handleCheckboxChange = (productId, isChecked) => {
        dispatch(toggleProductSelection({ productId, isChecked }));
    };



    const addtoCart = async (from, productId) => {
        // alert(from)
        if (!isLoggedin) {
            dispatch(setLoginpopup(true))
            return setShowLogin(true)
        }

        const products = selectedProducts?.map(product => (
            {
                productId: product?.product?._id,
                totalQty: parseInt(product?.quantity, 10) || 1,
                quantity: parseInt(product?.quantity, 10) || 1,
                status: product?.status
            }
        ))
        const isExist = products?.filter((i) => i?.status != true)

        if (isExist.length > 0) {
            return toast.error('The product which you have selected is not in our database please unselect and proceed')
        }
        if (from == 'cart') {
            setLoadingCart((prev) => ({ ...prev, [productId]: true }));
            const status = await dispatch(addToCartThunk(products))
            if (status?.payload === 200) {
                // navigate('/cart')
            }
            setLoadingCart((prev) => ({ ...prev, [productId]: false }));
        }
        else {
            setScheduleloading((prev) => ({ ...prev, [productId]: true }));
            const status = await dispatch(addToScheduleThunk(products))

            if (status?.payload === 200) {
                // navigate('/scheduleCart')
            }
            setScheduleloading((prev) => ({ ...prev, [productId]: false }));
        }
    }

    const addSingleProductsToCart = async (from, product) => {
        // alert(from)
        if (!isLoggedin) {
            dispatch(setLoginpopup(true))
            return setShowLogin(true)
        }
        console.log(product);

        if (product?.status == false) {
            return toast.error('The product which you have selected is not in our database please unselect and proceed')
        }

        const products = [{
            productId: product?.product?._id,
            totalQty: parseInt(product?.quantity, 10) || 1,
            quantity: parseInt(product?.quantity, 10) || 1,
            status: product?.status
        }]

        if (from == 'cart') {
            setLoadingCart((prev) => ({ ...prev, [product?.productNumber]: true }));
            const status = await dispatch(addToCartThunk(products))
            if (status?.payload === 200) {
                // navigate('/cart')
            }
            setLoadingCart((prev) => ({ ...prev, [product?.productNumber]: false }));
        }
        else {
            setScheduleloading((prev) => ({ ...prev, [product?.productNumber]: true }));
            const status = await dispatch(addToScheduleThunk(products))

            if (status?.payload === 200) {
                // navigate('/scheduleCart')
            }
            setScheduleloading((prev) => ({ ...prev, [product?.productNumber]: false }));
        }
    }

    const handleSelectAlternate = (originalItem, alternateProductNumber) => {

        const isAlreadyExist = productData.some(item => item.productNumber === alternateProductNumber);

        if (isAlreadyExist) {
            toast.error("Product already exists!");
            return;
        }

        const filter = selectedProducts?.filter((i) => i?.productNumber != originalItem)
        dispatch(setSelectedProducts(filter))

        const updatedData = productData.map(item =>
            item.productNumber === originalItem
                ? { ...item, productNumber: alternateProductNumber, manufacturer: '' }
                : item
        );

        setProductData(updatedData);
        navigate(location.pathname, {
            state: { data: updatedData },
            replace: true
        });
    };


    const handleEdit = () => {
        if (!newPartNumber) return;

        const isDuplicate = productData.some(item => item.productNumber === newPartNumber);
        if (isDuplicate) {
            toast.error("This part number already exists!");
            return;
        }

        const filter = selectedProducts?.filter((i) => i?.productNumber != editingProduct)

        dispatch(setSelectedProducts(filter))

        // Create the updated data first
        const updatedData = productData.map(item =>
            item.productNumber === editingProduct
                ? { ...item, productNumber: newPartNumber, manufacturer: "" }
                : item
        );

        // Update local state
        setProductData(updatedData);
        setEditingProduct(null);


        navigate(location.pathname, {
            state: { data: updatedData },
            replace: true
        });


    };


    const handleEditClick = (product) => {
        setEditingProduct(product);
        setNewPartNumber(product);
    };


    const addMoreData = (productNumber, e) => {

        e.preventDefault()
        const isExisting = productData?.some(item => item.productNumber === productNumber);

        if (isExisting) {
            toast.error('product already exist in the list')
            return; // Stop execution if the product exists
        }
        const newData = [...(productData || []), {
            productNumber: productNumber,
            quantity: 1,
            manufacturer: ''
        }];
        console.log(newData);

        setProductData(newData)
        navigate(location.pathname, {
            state: { data: newData },
            replace: true
        });

    };

    const handleDelete = () => {
        const productss = productData?.filter(product =>
            !selectedProducts.some(selected => selected === product.productNumber)
        );
        dispatch(setSelectedProducts([]))
        setProductData(productss)
        navigate(location.pathname, {
            state: { data: productss },
            replace: true
        });
    }


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                loading....
            </div>
        )
    }




    return (
        <>
            <div className={styles.imgBread}>
                <span>BOM Listing</span>
            </div>
            <div className={styles.crossContainer}>
                {/* {showLogin &&
                    <div className={styles.myList}>
                        <div className={styles.displayFlex}>
                            <div className={styles.bell}>
                                <img src='assets/bell.png' />
                            </div >
                            <div className={styles.access}>
                                <span className={styles.popupuploadLink} onClick={() => navigate('/login')} style={{ cursor: 'pointer', color: '#512DA8' }}>Login</span>&nbsp; or &nbsp;
                                <span className={styles.popupuploadLink} onClick={() => navigate('/customerRegn')} style={{ cursor: 'pointer', color: '#512DA8' }}>Register</span>     to save this list for future use and access all of the myLists features.
                            </div>
                        </div>
                      
                    </div>
                } */}

                <BomListTable
                    products={Array.isArray(macthedProducts) ? macthedProducts.filter(p => {
                        const num = p?.productNumber ? String(p.productNumber).trim().toLowerCase() : '';
                        return num && num !== 'id' && num !== '-';
                    }) : []}
                    handleCheckboxChange={handleCheckboxChange}
                    addtoCart={addtoCart}
                    quantities={quantities}
                    cartLoading={cartLoading}
                    scheduleLoading={scheduleLoading}
                    handleQuantityChange={handleQuantityChange}
                    // queryParams={queryParams}
                    handleSelectAlternate={handleSelectAlternate}
                    editingProduct={editingProduct}
                    handleSubmit={handleEdit}
                    newPartNumber={newPartNumber}
                    setEditingProduct={setEditingProduct}
                    setNewPartNumber={setNewPartNumber}
                    handleEditClick={handleEditClick}
                    setProductData={setProductData}
                    productData={productData}
                    setShowLogin={setShowLogin}
                    isLoggedin={isLoggedin}
                    addMoreData={addMoreData}
                    dropdownRef={dropdownRef}
                    handleDelete={handleDelete}
                    addSingleProductsToCart={addSingleProductsToCart}
                />

            </div>
        </>
    )
}

export default BomListing